/**
 * @group Contact
 * @summary Default contact message
 * 
 * @remarks
 * This constant contains the default message used in contact forms and
 * social media links for pre-filling communication content.
 * 
 * @example
 * ```typescript
 * import { MESSAGE } from '@shared/constants';
 * 
 * const whatsappLink = `https://api.whatsapp.com/send?text=${encodeURIComponent(MESSAGE)}`;
 * ```
 */
export const MESSAGE = "Hello, I'm interested in your services. Can you please provide me with more information?"; 